export class LineTypeAccount {
    requestType: string;
    lineType: string;
    entryType: string;
    line: number;
    mcu?: string;
    obj?: string;
    sub?: string;
    enteredByName?: string;
    updatedByName?: string;
    dateUpdated?: Date;
    dateEntered?: Date;
    enteredByEmail?: string;
    updatedByEmail?: string;    
}